module.exports = __webpack_public_path__ + "img/JalilKakaWais-bedgoran.d8401a80.jpg";